<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<div class="ctrl-bar">
  <button type="button" (click)="isVertical = !isVertical" class="toggle-btn">
    {{ isVertical ? '⤹ Horizontal' : '⤹ Vertical' }}
  </button>
</div>

<div class="main-tree" [ngClass]="{ horizontal: isVertical }">
  <ng-container *ngFor="let branch of branchList">
    <ng-template
      [ngTemplateOutlet]="nodeTemplateRef"
      [ngTemplateOutletContext]="{ $implicit: branch }"
    ></ng-template>
  </ng-container>
</div>

<ng-template #nodeTemplateRef let-node>
  <div class="child" [ngClass]="{ root: node.ParentNodeId == null }">
    <div class="card" [ngClass]="{ leaf: !node.Children || node.Children.length == 0 }">
      <div class="topbar">{{ node.NodeLevel }}</div>
      <div class="nm">{{ node.NodeName }}</div>
      <div class="stats" *ngIf="getNextCount(node) > 0 || node.BranchCount > 0">
        <span class="nx" *ngIf="getNextCount(node) > 0">{{ getNextLabel(node.NodeLevel) }}: {{ getNextCount(node) }}</span>
        <span class="br" *ngIf="node.BranchCount > 0 && node.NodeLevel !== 'Cluster'">Branches: {{ node.BranchCount }}</span>
      </div>
    </div>
    <div *ngIf="node.Children && node.Children.length" class="children">
      <ng-template
        ngFor
        let-childNode
        [ngForOf]="node.Children"
        [ngForTemplate]="nodeTemplateRef"
      ></ng-template>
    </div>
  </div>
</ng-template>
